import { getLocale } from "./i18n";
import { ILiftStatusWebComponentError } from "./types";

export const getStoreUnavailableError = (
  locale?: string
): ILiftStatusWebComponentError => {
  getLocale(locale);

  return {
    hasError: true,
    messageKey: "STORE_UNAVAILABLE",
    type: "",
  };
};
